import { ContentCopy } from "@mui/icons-material/";
import { CircularProgress, List, ListItem, TextField, Tooltip } from "@mui/material";
import qs from "query-string";
import React, { useContext, useEffect, useState } from "react";

import DataContext from "../../../../context/DataContext";
import { useDebouncedEffect } from "../../../../hooks/useDebounceEffect";
import axios from "../../../api/axios";
import { CustomChip } from "../../../global/CustomQueryChip";
import MultiSelectSearchV2 from "../../../global/MultiSelectSearchV2";
import PaginationControls from "../../../global/PaginationControls";
// import SearchOptionGroup from "../../../global/SearchOptionGroup";

export default function CaseManagerContact() {
  const { userRoles, userType } = useContext(DataContext);
  const [caseManagers, setCaseManagers] = useState();
  const [copiedAlert, setCopiedAlert] = useState(`Copy`);
  const [lawfirmNames, setLawfirmNames] = useState();
  const [resultCount, setResultCount] = useState({ total: "", current: "" });
  const [paginationUrl, setPaginationUrl] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedEntities, setSelectedEntities] = useState([]);
  const [activeEntities, setActiveEntities] = useState([]);
  // const [entityIsNull, setEntityIsNull] = useState(null);

  useEffect(() => {
    if (userRoles.permissions.includes("lawyer.view_lawfirm")) {
      const lfObj = {};

      axios
        .get(`/api/lawfirm/?limit=1000`, {
        })
        .then((response) => {
          const data = response.data.results;

          for (const item in data) {
            lfObj[data[item].pk] = data[item].name;
          }

          setLawfirmNames(lfObj);
        });
    } else {
      return;
    }
  }, [setLawfirmNames, userRoles.permissions]);

  const copyToClipboard = (value, name, type) => {
    navigator.clipboard.writeText(value);
    setCopiedAlert(`Copied ${name}'s ${type === "phone" ? "phone number" : "email"}`);
  };

  const columnClasses = userType !== "Law Firm" ? "md:w-1/4" : "md:w-1/3";

  const handleChange = (event, value) => {
    setCurrentPage(value);
    if (value === 1) {
      setPaginationUrl(`?limit=25&`);
      return;
    }
    setPaginationUrl(`limit=25&offset=${25 * (value - 1)}&`);
  };

  const resetPagination = () => {
    setPaginationUrl("");
    setCurrentPage(1);
  };

  useDebouncedEffect(
    () => {
      if (userRoles.permissions.includes("users.view_user")) {
        const querytest = qs.stringify(
          {
            search: search === "" ? null : search,
            // entity__isnull: entityIsNull === null ? null : entityIsNull,
          },
          {
            skipNull: true,
          }
        );
        const entitiesQuery =
          selectedEntities.length === 0 ? "" : `&entity__in=${selectedEntities}`;
        axios
          .get(
            `/api/users/contact_list/?${paginationUrl}&ordering=${
              selectedEntities.length === 0 ? "name" : "entity"
            }&${querytest}${entitiesQuery}`,
            {
            }
          )
          .then((response) => {
            setResultCount({
              total: response.data.count,
              current: response.data.results.length,
            });
            setCaseManagers(response.data.results);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        setLoading(false);
      }
    },
    [paginationUrl, setCurrentPage, search, userRoles.permissions, selectedEntities],
    250
  );

  return (
    <div className="bg-white px-6 py-10">
      <div className="mb-4 rounded-md border-2 border-purple-800 p-4">
        <h2 className="text-center text-xl font-bold">Emails</h2>
        <div className="m-auto w-fit">
          <List>
            <ListItem className="flex-col justify-center md:flex-row">
              <strong>Law Intake :</strong> <span className="hidden md:block">&nbsp;</span>
              <a
                href={`mailto:law.intake@healthnsync.com`}
                target="_blank"
                className="hover:underline"
                rel="noreferrer"
              >
                law.intake@healthnsync.com
              </a>
              <span className="hidden md:block">&nbsp;</span>
              <Tooltip title={copiedAlert}>
                <ContentCopy
                  onClick={() =>
                    copyToClipboard("law.intake@healthnsync.com", "Law Intake", "email")
                  }
                  onMouseLeave={() => setCopiedAlert("Copy")}
                />
              </Tooltip>
            </ListItem>
            <ListItem className="flex-col justify-center md:flex-row">
              <strong>Law Admin :</strong> <span className="hidden md:block">&nbsp;</span>
              <a
                href={`mailto:law.admin@healthnsync.com
                `}
                target="_blank"
                rel="noreferrer"
                className="hover:underline"
              >
                law.admin@healthnsync.com
              </a>
              <span className="hidden md:block">&nbsp;</span>
              <Tooltip title={copiedAlert}>
                <ContentCopy
                  onClick={() => copyToClipboard("law.admin@healthnsync.com", "Law Admin", "email")}
                  onMouseLeave={() => setCopiedAlert("Copy")}
                />
              </Tooltip>
            </ListItem>
            <ListItem className="flex-col justify-center md:flex-row">
              <strong>Information Tech (IT) :</strong>{" "}
              <span className="hidden md:block">&nbsp;</span>
              <a
                href={`mailto:it@healthnsync.com

                `}
                target="_blank"
                rel="noreferrer"
                className="hover:underline"
              >
                it@healthnsync.com
              </a>
              <span className="hidden md:block">&nbsp;</span>
              <Tooltip title={copiedAlert}>
                <ContentCopy
                  onClick={() =>
                    copyToClipboard("it@healthnsync.com", "Information Tech (IT)", "email")
                  }
                  onMouseLeave={() => setCopiedAlert("Copy")}
                />
              </Tooltip>
            </ListItem>
            <ListItem className="flex-col justify-center md:flex-row">
              <strong>Medical Billing/Docs :</strong>{" "}
              <span className="hidden md:block">&nbsp;</span>
              <a
                href={`mailto:med@healthnsync.com`}
                target="_blank"
                rel="noreferrer"
                className="hover:underline"
              >
                med@healthnsync.com
              </a>
              <span className="hidden md:block">&nbsp;</span>
              <Tooltip title={copiedAlert}>
                <ContentCopy
                  onClick={() => copyToClipboard("med@healthnsync.com", "Medical Billing", "email")}
                  onMouseLeave={() => setCopiedAlert("Copy")}
                />
              </Tooltip>
            </ListItem>
            <ListItem className="flex-col justify-center md:flex-row">
              <strong>Crash reports/PD/accident pics :</strong>
              <span className="hidden md:block">&nbsp;</span>
              <a
                href={`mailto:info@healthnsync.com`}
                target="_blank"
                rel="noreferrer"
                className="hover:underline"
              >
                info@healthnsync.com
              </a>
              <span className="hidden md:block">&nbsp;</span>
              <Tooltip title={copiedAlert}>
                <ContentCopy
                  onClick={() =>
                    copyToClipboard(
                      "info@healthnsync.com",
                      "Crash reports/PD/accident pic",
                      "email"
                    )
                  }
                  onMouseLeave={() => setCopiedAlert("Copy")}
                />
              </Tooltip>
            </ListItem>
          </List>
        </div>
      </div>
      <div className="mb-4">
        {" "}
        <CustomChip
          setActiveItems={setActiveEntities}
          activeItems={activeEntities}
          selectedItems={selectedEntities}
          setSelectedItems={setSelectedEntities}
          title="Entities"
          resetPagination={resetPagination}
        />
      </div>
      <div className="relative flex items-center pb-2">
        <div className="w-1/2">
          <Tooltip title="Search">
            <TextField
              className="w-full rounded-lg text-sm placeholder:text-center"
              placeholder="Search"
              size="small"
              name="search"
              value={search}
              InputLabelProps={{ shrink: true }}
              label="Search"
              onChange={(e) => {
                setSearch(e.target.value);
                resetPagination();
              }}
            />
          </Tooltip>
        </div>
        {userRoles.permissions.includes("users.view_entity") ? (
          <div className="absolute right-0 top-0 z-10 mx-4 w-[45%] rounded-md bg-white px-4 py-2 shadow-md">
            <MultiSelectSearchV2
              title="Sort by Entities"
              searchTitle="Entities"
              selectedItems={selectedEntities}
              setSelectedItems={setSelectedEntities}
              setActiveItems={setActiveEntities}
              activeItems={activeEntities}
              resetPagination={resetPagination}
              nameKey={"name"}
              valueKey={"pk"}
              apiUrl="/api/entities/contact_list/?"
            />
          </div>
        ) : (
          ""
        )}
        {/* <div className="w-[30%] mx-4 absolute right-[32%] top-0 z-10">
          <SearchOptionGroup
            setValue={setEntityIsNull}
            value={entityIsNull}
            title="Needs Entity"
            resetPagination={resetPagination}
          />
        </div> */}
      </div>
      <List className="grid max-h-[50vh] overflow-y-auto">
        {loading ? (
          <div className="my-24 flex justify-center">
            <CircularProgress color="secondary" />
          </div>
        ) : caseManagers.length === 0 ? (
          <div className="my-24 flex justify-center">No Results</div>
        ) : (
          <>
            {!caseManagers
              ? ""
              : caseManagers.map((cm, index) => (
                  <ListItem className="items-center px-2 py-4 pt-0 md:px-4" key={index + cm.name}>
                    <div
                      className={
                        "my-1 flex w-full flex-col items-center justify-between rounded-md py-1 text-black shadow-md md:flex-row"
                      }
                    >
                      <div className={`block ${columnClasses} pb-2 pl-2 text-left md:pb-0`}>
                        {!cm.name ? "Unknown" : cm.name}
                      </div>
                      <div
                        className={`${columnClasses} flex flex-col items-center pb-2 pl-2 text-left text-center md:block md:pb-0 lg:flex-row`}
                      >
                        {!cm.phone ? (
                          "Unknown"
                        ) : (
                          <>
                            <Tooltip title={copiedAlert}>
                              <button
                                id="phone-btn"
                                className="mr-2 border-0 bg-none"
                                onClick={() => {
                                  copyToClipboard(cm.phone, cm.name, "phone");
                                }}
                                onMouseLeave={() => setCopiedAlert("Copy")}
                              >
                                {!cm ? "" : cm.phone}
                              </button>
                            </Tooltip>
                          </>
                        )}
                      </div>
                      <div
                        className={`${columnClasses} flex flex-col items-center pb-2 pl-2 text-left text-center md:hidden md:pb-0 lg:flex-row`}
                      >
                        {!cm.phone ? (
                          "Unknown"
                        ) : (
                          <>
                            <Tooltip title={copiedAlert}>
                              <button
                                id="phone-btn-2"
                                className="mr-2 border-0 bg-none"
                                onClick={() => {
                                  copyToClipboard(cm.phone, cm.name, "phone");
                                }}
                                onMouseLeave={() => setCopiedAlert("Copy")}
                              >
                                {!cm ? "" : cm.phone}
                              </button>
                            </Tooltip>
                          </>
                        )}
                      </div>
                      <div
                        className={`${columnClasses} ml-2 pb-2 pl-2 text-left text-center text-sm md:pb-0`}
                      >
                        {!cm.email ? (
                          "Unknown"
                        ) : (
                          <>
                            <a
                              href={`mailto:${cm.email}`}
                              target="_blank"
                              rel="noreferrer"
                              className="break-words hover:underline"
                            >
                              {!cm.email ? "" : cm.email}
                            </a>
                            &nbsp;
                            <Tooltip title={copiedAlert}>
                              <ContentCopy
                                onClick={() => copyToClipboard(cm.email, cm.name, "email")}
                                onMouseLeave={() => setCopiedAlert("Copy")}
                              />
                            </Tooltip>
                          </>
                        )}
                      </div>
                      {userType !== "Law Firm" ? (
                        <span
                          className={`block border-none pb-2 pl-2 text-left text-center md:w-1/5 md:pb-0`}
                        >
                          {!lawfirmNames ? "" : lawfirmNames[cm.works_for_law_firm_pk]}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </ListItem>
                ))}
            <ListItem className={`justify-center py-10`}>
              <PaginationControls
                resultCount={resultCount}
                handleChange={handleChange}
                currentPage={currentPage}
              />
            </ListItem>
          </>
        )}
      </List>
    </div>
  );
}
